export function IsURL(aString) {
  //   toString().
  aString = aString.toLowerCase();
  if (
    aString.indexOf("http://") === 0 ||
    aString.indexOf("https://") === 0 ||
    aString.indexOf("//www.") === 0
  )
    return true;

  if (aString.indexOf("/wfn/hr/v1") === 0 || aString.indexOf("/hr/v2/workers/") > -1) return true;

  if (aString.indexOf("/google/") === 0) return true;

  if (aString.indexOf("/sfsf/") === 0) return true;

  if (aString.indexOf("/namely/") === 0) return true;

  if (aString.indexOf("/igloo/") === 0) return true;

  if (aString.indexOf("/o365/") === 0) return true;

  if (aString.indexOf("/wfn/ocn/") === 0) return true;

  if (aString.indexOf("oraclecloud") === 0) return true;
  if (aString.indexOf("/workday/") === 0) return true;
  if (aString.indexOf("bamboohr/") === 0) return true;
  if (aString.indexOf("paycom/") === 0) return true;
  if (aString.indexOf("breathehr=") > -1 && aString.indexOf("eid=") === 0) return true;
  if (aString.indexOf("payspace=") > -1 && aString.indexOf("eid=") === 0) return true;
  if (aString.indexOf("/toyota/") === 0) return true;
  if (aString.indexOf("/jemini/") === 0) return true;
  if (aString.indexOf("/isolved/") === 0) return true;

  return false;
}
